module.exports = __webpack_public_path__ + "img/cmptr.rekabet.9a81d8a2.png";